import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { ConfigService } from '../../config/config.service';
import { NotificationComponent } from '../notification.component';
import { NotificationType } from './notification-type';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(
    public snackBar: MatSnackBar,
    private configService: ConfigService,
    private http: HttpClient
  ) { }

  public notif(text: string, type: NotificationType, time: number = 4000) {
    return this.snackBar.openFromComponent(NotificationComponent, {
      duration: time,
      direction: 'ltr',
      verticalPosition: 'top',
      data: {
        message: text,
      },
      panelClass: type
    });
  }

  public getAppEnv(): Observable<string> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<string>(config.apiPoint + config.getAppEnv, { withCredentials: false });
      })
    );
  }

  public close() {
    this.snackBar.dismiss()
  }
}
